import apiDev from './api.dev';
import apiProd from './api.prod';

const apiConfig = process.env.NODE_ENV === 'production' ? apiProd : apiDev;

const config = {
    apiInfo: apiConfig,
    requestConfig: 'development' // development or production
};

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js